import { render, staticRenderFns } from "./menu_zeleris.vue?vue&type=template&id=c8f318da&"
import script from "./menu_zeleris.vue?vue&type=script&lang=js&"
export * from "./menu_zeleris.vue?vue&type=script&lang=js&"
import style0 from "./menu_zeleris.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
